import { Badge, Box, Button, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  ParticipationRequestStatus,
  useListMyParticipationRequestsQuery,
} from "../../../autogen/bff-api";
import { participationStatusBadge } from "../../../common/qualification/participationStatusBadge";
import { usePortalEventUrls } from "../../sourcing-events/portal/usePortalEventUrls";

// Forespørsler om å delta in two-stage competitions. Rendered only when the org has any —
// suppliers who never touch begrenset procedures never see this section.
export const MyParticipationRequestsSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const portalUrls = usePortalEventUrls();
  const { data } = useListMyParticipationRequestsQuery({});
  const rows = data?.rows ?? [];

  if (rows.length === 0) return null;

  return (
    <Box pb="8">
      <Box py="5">
        <Text fontSize="medium" color="smMuted">
          {t("Your requests to participate in two-stage competitions")}
        </Text>
      </Box>
      <Box border="1px solid" borderColor="smBorder" rounded="md" overflowX="auto">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>{t("Event")}</Th>
              <Th>{t("Buyer")}</Th>
              <Th>{t("Deadline for requests to participate")}</Th>
              <Th>{t("Status")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {rows.map(({ request, eventId, eventTitle, buyerOrganizationName, requestDeadline }) => {
              // § 16-12 (4): qualified but not selected reads as its own outcome, not as "Qualified".
              // Dynamic key for langen: t('Not selected')
              const notSelected = request.selectionOutcome != null && !request.selectionOutcome.selected;
              const badge = notSelected
                ? { colorScheme: "orange", labelKey: "Not selected" }
                : participationStatusBadge(request.status, "Submitted");
              const target =
                request.status === ParticipationRequestStatus.Draft
                  ? portalUrls.request.edit.go(eventId, request.id).intro
                  : portalUrls.view.go(eventId);
              return (
                <Tr key={request.id}>
                  <Td width="80" maxWidth="80" overflow="hidden" textAlign="left">
                    <Button
                      variant="link"
                      colorScheme="teal"
                      textAlign="left"
                      whiteSpace="pre-wrap"
                      onClick={() => navigate(target)}
                    >
                      {eventTitle ?? t("Unknown")}
                    </Button>
                  </Td>
                  <Td>
                    <Text>{buyerOrganizationName}</Text>
                  </Td>
                  <Td>
                    <Text>{requestDeadline ? moment(requestDeadline).format("ll") : "–"}</Text>
                  </Td>
                  <Td>
                    <Badge colorScheme={badge.colorScheme}>{t(badge.labelKey)}</Badge>
                    {notSelected && request.selectionOutcome?.reason && (
                      <Text fontSize="xs" color="smMuted" mt="1" maxW="64" noOfLines={2}>
                        {request.selectionOutcome.reason}
                      </Text>
                    )}
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};


